// extracted by mini-css-extract-plugin
export default {"wrapperSm":"Loader_wrapperSm__gxy5s","wrapperMed":"Loader_wrapperMed__GLJ6Q","wrapperFull":"Loader_wrapperFull__NTol9"};